import {
  CommonSelect,
  DatePicker,
  Input,
  LoadingButton,
  Select,
  SwitchButton,
  TextArea,
} from "components/form";
import { useEffect, useState } from "react";
import { FaArrowRight } from "react-icons/fa";
import { surveyCategoryListApi } from "services/master";
import {
  formatMultiSelectArray,
  handleDynamicList,
  isObjectEmpty,
  removeEmptyValues,
  validateOnlyNumber,
} from "utils/commonHelper";

import {
  addDaysToDateString,
  addYearsToDateString,
  toDate,
} from "utils/dateHelper";
import SurveyInfo from "./SurveyInfo";
import { getFromLocal } from "config/axiosInstance";
import { SURVEY_DURATION } from "constant/staticData";
import { LuInfo } from "react-icons/lu";
import { useNavigate, useSearchParams } from "react-router-dom";
import { createSurveyApi, surveyDetailsApi } from "services/survey";
import {
  handleDecryptionParams,
  handleEncryptionParams,
} from "utils/dataCipherHelper";
import { toastMessage } from "utils/toastMessageHelper";
import { removeErrorFields, validateInput } from "validation";
import { survey } from "../../../validation/schema/survey";
import { useTranslation } from "react-i18next";
import useShimmer from "hooks/useShrimmer";
import StructurePreviewShimmer from "shrimmer/Survey/StructurePreviewShimmer";

const ParticipantCriteria = () => {
  // All Set Value
  const [searchParams, setSearchParams] = useSearchParams();
  const [showShimmer, setShowShimmer] = useShimmer(StructurePreviewShimmer);
  const navigate = useNavigate();

  const { t } = useTranslation();

  const getParamsData = handleDecryptionParams(
    searchParams.get("data"),
    setSearchParams
  );

  console.log("getParamsData:", getParamsData);

  const [createSurveyValue, setCreateSurveyValue] = useState({
    stage: 2,
    hideIdentity: false,
    surveyCreatedFrom: "own",
  });
  const [error, setError] = useState({});

  const [selectedFilters, setSelectedFilters] = useState({
    gender: "",
    // age: "",
    educationLevel: "",
    livingSituation: "",
    region: "",
    employementInfo: "",
    martialStatus: "",
    annualIncome: "",
    duration: "",
    surveyCategory: "",
  });
  const [surveyCategoryList, setSurveyCategoryList] = useState([]);
  const [surveyButtonLoader, setSurveyButtonLoader] = useState(false);

  // Handlers function

  // Fetch Survey Category list Handler

  const fetchSurveyCategoryList = async () => {
    try {
      const response = await surveyCategoryListApi();
      if (response.status === 200) {
        const { surveyCategory = [] } = response.data || {};
        setSurveyCategoryList(surveyCategory);
      }
    } catch (e) {
      console.error("Error fetching survey categories:", e.message);
    }
  };

  // Input Validation function
  const validation = () => {
    const { errors, status } = validateInput(
      createSurveyValue,
      "createSurveySchema",
      survey,
      null
    );
    setError(errors);
    return status;
  };

  // Input change Handler
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    let updatedValue = value;

    if (["minAge", "maxAge"].includes(name)) {
      updatedValue = validateOnlyNumber(value);
    }
    setCreateSurveyValue((prev) => ({ ...prev, [name]: updatedValue }));
    setError((prevError) => removeErrorFields(prevError, name));
  };

  // Switch Change handler
  const handleSwitchChange = () => {
    setCreateSurveyValue((prev) => ({
      ...prev,
      hideIdentity: !prev.hideIdentity,
    }));
  };

  // Date change handler
  const handleDateChange = (dateValue) => {
    setCreateSurveyValue((prev) => ({
      ...prev,
      expiryDate: toDate(dateValue),
    }));
  };

  // Filter Chnage Handler
  const handleFilterChange = (filterKey, value) => {
    setSelectedFilters((prev) => ({
      ...prev,
      [filterKey]: value,
    }));

    setCreateSurveyValue({
      ...createSurveyValue,
      [filterKey]:
        formatMultiSelectArray(value, ",", true, "value") || value?.value,
    });

    setError((prevError) => removeErrorFields(prevError, filterKey));
  };

  // Set Stepper value handler
  // const handleStepperValue = () => {
  //   searchParams.set("stepper", 3);
  //   setSearchParams(searchParams);
  // };

  // Dropdown for multiple value

  const renderSelect = ({
    required,
    placeholder,
    arrayList,
    selectedKey,
    isMulti = true,
    labelKey = "label",
    valueKey = "value",
    sourcekey = "label",
    sourceValue = "value",
    error = null,
  }) => (
    <CommonSelect
      label={placeholder}
      required={required}
      placeholder={placeholder}
      options={handleDynamicList({
        arrayList,
        labelKey: labelKey,
        valueKey: valueKey,
        sourcekey: sourcekey,
        sourceValue: sourceValue,
      })}
      isSearchable
      isMulti={isMulti}
      error={error || null}
      value={selectedFilters[selectedKey]}
      onChange={(value) => handleFilterChange(selectedKey, value)}
    />
  );

  // // Create Survey function handler
  const createSurveyHandler = async (file) => {
    if (validation()) {
      try {
        setSurveyButtonLoader(true);
        const reqData = {
          ...createSurveyValue,
          token: getFromLocal() || "",
        };
        const responseData = await createSurveyApi(removeEmptyValues(reqData));
        const { data = {}, message = "", status: requstStatus } = responseData;
        if (requstStatus === 200) {
          toastMessage(message, "success", "createSurvey");
          const currentParamsData = {
            surveyId: data?.surveyId,
            stepper: 2,
          };
          const currentEncryptedParams = handleEncryptionParams(
            currentParamsData,
            null
          );
          navigate(`?data=${currentEncryptedParams}`, {
            replace: true,
          });
          const nextParamsData = {
            surveyId: data?.surveyId,
            stepper: 3,
            isDraft: getParamsData?.surveyId ? true : false,
          };
          const encryptedParams = handleEncryptionParams(
            nextParamsData,
            searchParams
          );
          setSearchParams(encryptedParams);
        }
      } catch (e) {
        console.log("Error:", e.message);
      } finally {
        setSurveyButtonLoader(false);
      }
    }
  };

  // Create Survey with Template function handler
  const createTemplateSurveyHandler = async (file) => {
    if (validation()) {
      try {
        setSurveyButtonLoader(true);
        const reqData = {
          ...createSurveyValue,
          token: getFromLocal() || "",
        };
        const responseData = await createSurveyApi(removeEmptyValues(reqData));
        const { data = {}, message = "", status: requstStatus } = responseData;
        if (requstStatus === 200) {
          toastMessage(message, "success", "createSurvey");
        }

        const currentParamsData = {
          surveyId: data?.surveyId,
          stepper: 2,
        };
        const currentEncryptedParams = handleEncryptionParams(
          currentParamsData,
          null
        );
        navigate(`?data=${currentEncryptedParams}`, {
          replace: true,
        });

        const nextParamsData = {
          stepper: 3,
          surveySlug: data?.surveyId,
          isTemplate: getParamsData?.isTemplate,
          templateSlug: getParamsData?.surveyTemplateSlug,
        };
        const encryptedParams = handleEncryptionParams(
          nextParamsData,
          searchParams
        );
        setSearchParams(encryptedParams);
      } catch (e) {
        console.log("Error:", e.message);
      } finally {
        setSurveyButtonLoader(false);
      }
    }
  };

  const fetchSelectedSurveyDetail = async (selectedSurveyId) => {
    try {
      setShowShimmer(true);
      const reqData = {
        surveyId: selectedSurveyId,
        token: getFromLocal(),
      };
      const responseData = await surveyDetailsApi(reqData);
      const {
        data: { surveyDetail = {} },
        status,
      } = responseData;
      if (status === 200) {
        if (!isObjectEmpty(surveyDetail)) {
          const {
            title,
            description,
            surveyCategory,
            expiryDate,
            duration,
            hideIdentity,
            _id,
          } = surveyDetail;
          setCreateSurveyValue((prev) => ({
            ...prev,
            surveyId: _id,
            title,
            description,
            surveyCategory: surveyCategory?._id,
            expiryDate,
            duration,
            hideIdentity,
          }));
          setSelectedFilters((prev) => ({
            ...prev,
            surveyCategory: {
              label: `${surveyCategory?.name}`,
              value: `${surveyCategory?._id}`,
            },
            duration: { label: `${duration} mins`, value: `${duration}` },
          }));
        }
      }
    } catch (e) {
      console.log("Error:", e.message);
    } finally {
      setShowShimmer(false);
    }
  };

  // selected survey Detail

  const selectedSurveyDetail = useEffect(() => {
    fetchSurveyCategoryList();
  }, []);

  const setDataIfFromTemplate = () => {
    setSelectedFilters((prev) => ({
      ...prev,
      surveyCategory: getParamsData?.selectedCategoryId,
    }));

    setCreateSurveyValue({
      ...createSurveyValue,
      title: getParamsData?.surveyTitle,
      description: getParamsData?.surveyDescription,
      surveyCategory: getParamsData?.selectedCategoryId,
    });
  };

  useEffect(() => {
    if (getParamsData?.isTemplate) {
      setDataIfFromTemplate();
    }

    // eslint-disable-next-line
  }, [getParamsData?.isTemplate]);

  useEffect(() => {
    if (getParamsData?.surveyId) {
      fetchSelectedSurveyDetail(getParamsData?.surveyId);
    }
  }, [getParamsData?.surveyId]);

  //************************* Handle HTML CODE ************************//
  return (
    <div className="participant_criteria">
      <h3 className="dashboard_title">
        {t("PARTICIPANT_CRITERIA.participantCriteria")}
      </h3>
      <div className="form_wrap">
        <div className="form_content">
          <form>
            {/* Step 1: Survey Details */}
            <div className="form_section">
              <div className="form_title">
                <h4>
                  <span className="sr_number">1</span>
                  {t("PARTICIPANT_CRITERIA.setSurveyDetail")}
                </h4>
                <div className="switch_wrap">
                  <span className="green">
                    {t("PARTICIPANT_CRITERIA.hideMyIdentity")}
                  </span>
                  <div className="tooltip_wrap">
                    <LuInfo />
                    <span className="tooltip_content">
                      {t("PARTICIPANT_CRITERIA.hideMyIdentityDescription")}
                    </span>
                  </div>
                  <SwitchButton
                    status={createSurveyValue.hideIdentity}
                    onChange={handleSwitchChange}
                  />
                </div>
              </div>
              <div className="form_field">
                <Input
                  type="text"
                  name="title"
                  maxLength={100}
                  required={true}
                  error={error?.title}
                  label={t("PARTICIPANT_CRITERIA.surveyTitle")}
                  onChange={handleInputChange}
                  placeholder={t("PARTICIPANT_CRITERIA.enterSurveyTitle")}
                  value={createSurveyValue.title || ""}
                />
              </div>
              <div className="form_field_wrap">
                <div className="form_field">
                  {getParamsData?.isTemplate ? (
                    <div>
                      <Select
                        disabled
                        required
                        label={t("PARTICIPANT_CRITERIA.selectCategory")}
                        name="surveyCategory"
                        placeholder={t("PARTICIPANT_CRITERIA.selectCategory")}
                        value={createSurveyValue?.surveyCategory}
                      >
                        {surveyCategoryList?.length > 0 &&
                          surveyCategoryList.map(({ _id, name }) => (
                            <option key={_id} value={_id}>
                              {name}
                            </option>
                          ))}
                      </Select>
                    </div>
                  ) : (
                    renderSelect({
                      required: true,
                      placeholder: t("PARTICIPANT_CRITERIA.selectCategory"),
                      arrayList: surveyCategoryList,
                      selectedKey: "surveyCategory",
                      isMulti: false,
                      labelKey: "name",
                      valueKey: "_id",
                      error: error?.surveyCategory || null,
                    })
                  )}
                </div>
                <div className="form_field">
                  <DatePicker
                    required={true}
                    name="expiryDate"
                    autoComplete="off"
                    label={t("PARTICIPANT_CRITERIA.expiryDate")}
                    placeholder={t("PARTICIPANT_CRITERIA.expiryDate")}
                    value={createSurveyValue.expiryDate || ""}
                    onChange={handleDateChange}
                    minDate={toDate(addDaysToDateString(new Date(), 1))}
                    maxDate={toDate(addYearsToDateString(new Date(), 1))}
                    error={error?.expiryDate}
                  />
                </div>
              </div>
              <div className="form_field_wrap">
                <div className="form_field">
                  {renderSelect({
                    required: true,
                    placeholder: t("PARTICIPANT_CRITERIA.estimateTimeDuration"),
                    arrayList: SURVEY_DURATION,
                    selectedKey: "duration",
                    isMulti: false,
                    error: error?.duration || null,
                  })}
                </div>
              </div>
            </div>

            {/* Step 2: Survey Overview */}
            <div className="form_section">
              <div className="form_title">
                <h4>
                  <span className="sr_number">2</span>
                  {t("PARTICIPANT_CRITERIA.surveyOverview")}
                </h4>
              </div>
              <div className="form_field has_word_count">
                <TextArea
                  required={true}
                  label={t("PARTICIPANT_CRITERIA.surveyDescription")}
                  placeholder={t("PARTICIPANT_CRITERIA.enterSurveyDescription")}
                  style={{ resize: "none" }}
                  name="description"
                  value={createSurveyValue.description || ""}
                  onChange={handleInputChange}
                  maxLength={500}
                  error={error?.description}
                />
                <span className="word_count">{`${
                  createSurveyValue.description?.length || 0
                }/500`}</span>
              </div>
            </div>
          </form>
        </div>

        <div className="form_summery_wrap">
          <SurveyInfo
            showFooter={true}
            surveyDetail={selectedFilters}
            selectedSurveyDetail={createSurveyValue}
          />

          <div className="button_wrap">
            {!getParamsData?.isTemplate ? (
              <LoadingButton
                onClick={createSurveyHandler}
                loading={surveyButtonLoader}
              >
                {!getParamsData?.surveyId
                  ? t("PARTICIPANT_CRITERIA.createSurvey")
                  : t("PARTICIPANT_CRITERIA.updateSurvey")}
                <FaArrowRight />
              </LoadingButton>
            ) : (
              <LoadingButton
                loading={surveyButtonLoader}
                onClick={createTemplateSurveyHandler}
              >
                {t("PARTICIPANT_CRITERIA.createSurvey")} <FaArrowRight />
              </LoadingButton>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ParticipantCriteria;
